module.exports = __webpack_public_path__ + "img/slider-1.bb569bef.jpg";